import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  inputRoot: {
    width: '100%',
  },
  select: {
    width: '100%',
    minHeight: '40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    fontSize: 14,

    '&>div': {
      width: '100%',
    },
    '& .css-yk16xz-control': {
      minHeight: '40px',
    },
    '& .css-1pahdxg-control': {
      minHeight: '40px',
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
    },
    '& .css-1pahdxg-control:hover': {
      borderColor: theme.palette.primary.main,
    },
    '& .Select__menu': {
      zIndex: 4,
    },
    '& .Select__indicator-separator': {
      display: 'none',
    },
    '& > *': {
      width: '100%',
    },
    '& .Select__value-container': {
      width: '90%',
    },
    '& .Select__placeholder': {
      fontSize: 15,
    },
    '& .Select__single-value': {
      fontSize: 15,
    },
  },
  error: {
    '& .Select__control': {
      borderColor: theme.palette.error.main,
      '&:hover': {
        borderColor: theme.palette.error.main,
      },
      '&:focus': {
        borderColor: theme.palette.error.main,
      },
    },
    '& .Select__placeholder': {
      color: theme.palette.error.main,
    },
  },
  customOption: {
    background: theme.palette.lightGray.main,
    height: '100%',
    minHeight: 40,
    padding: theme.spacing(0.5),
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  label: {
    color: 'gray',
    marginBottom: theme.spacing(0.8),
    alignSelf: 'flex-start',
    minHeight: 16,
  },
}))

export default useStyles
